import * as actionTypes from 'constants/ActionTypes';
import _ from 'lodash';

const initState = {
    firstLoad: false,
    name: '',
    unLoCode: '',
    alt: [],
    country: {
        _id: undefined,
        name: undefined,
    },
    timezone: '',
    coordinates: [],
    site: '',
    parent: undefined,
    childs: [],
    area: undefined,
    areaParent: false,
    lastUpdate: {
        time: undefined,
    },
    autoCreated: false,
    facilities: {
        breakBulk: undefined,
        dryBulk: undefined,
        dryDock: undefined,
        container: undefined,
        liquid: undefined,
        lpg: undefined,
        lng: undefined,
        roro: undefined,
        passenger: undefined,
        multipurpose: undefined,
    },
    warehouses: {
        timber: undefined,
        grain: undefined,
        lpg: undefined,
        chemicals: undefined,
        dryBulk: undefined,
        liquid: undefined,
        general: undefined,
        reefer: undefined,
    },
    portLimitations: {
        maxDraught: undefined,
        maxDWT: undefined,
        cargoPier: undefined,
        anchorageDepth: undefined,
        maxBeam: undefined,
        channelDepth: undefined,
        meanTide: undefined,
        maxLOA: undefined,
    },
    liftsCranes: {
        '0-24': {
            checked: undefined,
            name: '0-24',
            label: '0-24 mt:',
            details: [
            ],
        },
        '25-49': {
            name: '25-49',
            label: '25-49 mt:',
            checked: undefined,
            details: [

            ],
        },
        '50-99': {
            name: '50-99',
            label: '50-99 mt:',
            checked: undefined,
            details: [],
        },
        '100-149': {
            name: '100-149',
            label: '100-149 mt:',
            checked: undefined,
            details: [],
        },
        '150+': {
            name: '150+',
            label: '150+ mt:',
            checked: undefined,
            details: [],
        },
    },
    serviceProviders: [],
    additionalDescription: undefined,
};

const port = (state = initState, action) => {
    switch (action.type) {
    case actionTypes.CLEAR_PORT:
        return initState;

    case actionTypes.GET_PORT.REQUEST:
        return {
            ...state,
            firstLoad: false,
        };
    case actionTypes.GET_PORT.SUCCESS: {
        if (action.data.serviceProviders && action.data.serviceProviders.length > 0) {
            action.data.serviceProviders.forEach((serviceProvider) => {
                if (!serviceProvider.limitations || !serviceProvider.limitations.length) {
                    serviceProvider.limitations = [{
                        maxDraught: undefined,
                        maxBeam: undefined,
                        maxLOA: undefined,
                        maxDWT: undefined,
                        channelDepth: undefined,
                        anchorageDepth: undefined,
                    }];
                }
            });
        }

        return _.merge({}, state, action.data, { firstLoad: true });
    }
    case actionTypes.GET_PORT.FAILURE:
        return {
            ...state,
        };


    case actionTypes.UPDATE_PORT.REQUEST:
        return {
            ...state,
            ...action.data,
        };
    case actionTypes.UPDATE_PORT.SUCCESS: {
        return {
            ...state,
            ...action.data,
        };
    }
    case actionTypes.UPDATE_PORT.FAILURE: {
        return {
            ...state,
        };
    }

    case actionTypes.ADD_NEW_PORT.REQUEST:
        return {
            ...state,
            ...action.data,
        };
    case actionTypes.ADD_NEW_PORT.SUCCESS: {
        return {
            ...state,
            ...action.data,
        };
    }
    case actionTypes.ADD_NEW_PORT.FAILURE: {
        return {
            ...state,
        };
    }

    case actionTypes.CHANGE_PORT: {
        const _data = _.cloneDeep(action.data);
        _data.serviceProviders && _data.serviceProviders.map((provider) => {
            if (!(provider.activities.includes('Stevedoring Company'))) {
                provider.limitations = [];
            }
        });

        return Object.assign({}, _.cloneDeep(state), _.cloneDeep(_data));
    }

    default:
        return state;
    }
};

export default port;



// WEBPACK FOOTER //
// ./app/reducers/regions/port.js